<template>
  <section>
    <!-- ROUTER HEADER SHOULD GO HERE -->
    <div class="page-banner">
      <div class="container-fluid border-bottom">
        <div class="row align-items-center">
          <div class="col-md-7 p-4 pt-5">
            <h1>
              <img
                src="@/assets/img/_title/16-OTJS-establish-smart-learning-goals.svg"
                class="img-fluid"
                alt="Establish SMART learning goals"
                srcset=""
              >
            </h1>
          </div>
        </div>
      </div>
    </div>

    <!-- ROUTER CONTENT GOES HERE -->

    <!-- TEXT CONTENT -->
    <content-block class="p-4 bg-light-grey" >
      <!-- <h2 class="content-block__header">Establish SMART learning goals</h2> -->
      <p>Once you’ve gone through the interview process and been offered the job, it’s a good idea to reflect on what you want to get out of your on-campus work experience.</p>
      <p>Specifically, what skills are you hoping to gain from this job?</p>
      <p>To help you figure this out, let’s explore SMART goals.</p>
      <p>To improve your chances of achieving a goal, it should be <strong>S</strong>pecific, <strong>M</strong>easurable, <strong>A</strong>chievable, <strong>R</strong>elevant and <strong>T</strong>ime-bound. </p>
    </content-block>
    <content-block class="p-4">
      <div class="row align-items-center">
        <!-- bg-img--job-search-17-SMART -->
        <div class="col-md">
          <img
            src="@/assets/img/_content/17.SMART-graphic-centennial.png"
            alt=""
            class="img-fluid"
          >
        </div>
        <div class="col-md-6 p-4">
          <ul>
            <li>Specific: What exactly do I want to achieve?</li>
            <li>Measurable: How will I know when I have achieved it?</li>
            <li>Achievable: Is it something I have control over?</li>
            <li>Relevant: How does this goal align with my broader goals?</li>
            <li>Time-bound: When can I accomplish this goal?</li>
          </ul>
        </div>
      </div>
    </content-block>

    <content-block class="p-4">
      <div class="learn-more learn-more--purple">
        <p><strong>Learn more</strong>
        <p>This <a
            :href="`${publicPath}docs/Worksheets/3-Establishing learning goals - worksheet 3.pdf`"
            target="_blank"
          >SMART goal activity</a> can help you come up with SMART goals for yourself. </p>
        <p>Once you start your work experience (or even before), communicate your goals with your supervisor. Your supervisor can help you refine these goals. Discuss what is doable and what isn’t, and come up with a plan to achieve the attainable goals.</p>
        <p>By setting clear goals before starting your job, you’ll be able to have a more focused and meaningful experience.</p>
      </div>
    </content-block>

  </section>
</template>

<script>
import ContentBlock from '@/components/ContentBlock.vue'
// import Accordion from '@/components/Accordion.vue'
// import SidebarMenu from '../components/SidebarMenu.vue'
// import {
//   Hooper,
//   Slide,
//   Navigation as HooperNavigation,
//   Pagination as HooperPagination
// } from 'hooper'
// import 'hooper/dist/hooper.css'

export default {
  name: '01',
  components: {
    ContentBlock
    // SidebarMenu,
    // Accordion
    // Hooper,
    // Slide,
    // HooperNavigation,
    // HooperPagination
  },
  data () {
    return {
      publicPath: process.env.BASE_URL
    }
  },

  mounted () {
  }
}
</script>

<style>
</style>
